import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { getAppName } from '@mode/shared/util-js';

@Component({
  standalone: true,
  selector: 'mode-studio',
  imports: [CommonModule],
  templateUrl: './mode-studio.component.html',
  styleUrls: ['./mode-studio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModeStudioComponent {
  readonly appName = getAppName({ isFree: true });
  @Input() orgUsername = '';
  @Input() theme: 'light' | 'dark' = 'light';
}
